export const RegistrationUtils = {
    REGISTRATION_COOKIE_NAME: "registrationToken"
}